var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKusamaParaIdSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_5145_24902)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3107 18.7325C13.7711 18.137 13.4812 17.3568 13.5009 16.5535C13.5207 15.7501 13.8487 14.9851 14.4169 14.4169C14.9851 13.8487 15.7501 13.5207 16.5535 13.5009C17.3568 13.4812 18.137 13.7711 18.7325 14.3107L29.6893 25.2675C30.2289 25.863 30.5188 26.6432 30.499 27.4465C30.4793 28.2499 30.1513 29.0149 29.5831 29.5831C29.0149 30.1513 28.2499 30.4793 27.4465 30.499C26.6432 30.5188 25.863 30.2289 25.2675 29.6893L14.3107 18.7325Z",
    stroke: "#1B202C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2675 14.3107C25.863 13.7711 26.6432 13.4812 27.4465 13.5009C28.2499 13.5207 29.0149 13.8487 29.5831 14.4169C30.1513 14.9851 30.4793 15.7501 30.499 16.5535C30.5188 17.3568 30.2289 18.137 29.6893 18.7325L18.7325 29.6893C18.137 30.2289 17.3568 30.5188 16.5535 30.499C15.7501 30.4793 14.9851 30.1513 14.4169 29.5831C13.8487 29.0149 13.5207 28.2499 13.5009 27.4465C13.4812 26.6432 13.7711 25.863 14.3107 25.2675L25.2675 14.3107Z",
    stroke: "#1B202C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5145_24902",
    x1: 0,
    y1: 0,
    x2: 44,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B202C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B202C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKusamaParaIdSquare);
export default __webpack_public_path__ + "static/media/kusama-para-id-square.8c21d89f3acca2f477700e1b3846dd05.svg";
export { ForwardRef as ReactComponent };